import PresentationDetails from './PresentationDetails'
export * from './PresentationDetails'
export default PresentationDetails
